import { useSyncExternalStore } from "react";
import { nativeUploadStatus, subscribeNativeUploadStatus } from "@/lib/native_upload_status";
export function useNativeUploadStatus() { return useSyncExternalStore(subscribeNativeUploadStatus, nativeUploadStatus); }
